import { render, staticRenderFns } from "./job-details.component.vue?vue&type=template&id=dcb80c50"
import script from "./job-details.component.ts?vue&type=script&lang=ts&external"
export * from "./job-details.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb80c50')) {
      api.createRecord('dcb80c50', component.options)
    } else {
      api.reload('dcb80c50', component.options)
    }
    module.hot.accept("./job-details.component.vue?vue&type=template&id=dcb80c50", function () {
      api.rerender('dcb80c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/job-setup/job-details/job-details.component.vue"
export default component.exports